// 对象转拼接参数
export function addQueryString(params) {
  var str = '';
  for (var Key in params) {
    str += Key + '=' + params[Key] + '&';
  }
  return str.substr(0, str.length - 1);
}
